import type { FC } from 'react';
import { Button, Flex, Icon, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { usePageContext } from 'vike-react/usePageContext';
import { getLinkHref } from '@/utils/getLinkHref';

export const AppliedStub: FC = () => {
    const pageContext = usePageContext();
    const { t } = useTranslation();
    return (
        <>
            <Icon.CheckCircle size={72} color="iconMain" />
            <Flex vertical align="center" gap={16}>
                <Typography.Heading level={2}>{t('Apply_Applied_Stub_Title')}</Typography.Heading>
                <Typography.Paragraph level={1}>{t('Apply_Applied_Stub_Description')}</Typography.Paragraph>
            </Flex>
            <Button
                href={getLinkHref(pageContext, '/')}
                variant="primary"
                size="m"
            >
                {t('Apply_Applied_Stub_Button')}
            </Button>
        </>
    );
};
